/* TimeLab: the box behind each product photo continues the photo's own background.
   1. The photo is reduced to a small grid. Its border pixels that look like real background (smooth, close
      to the border median) are kept; the watch and any bracelet touching the edge are discarded.
   2. The missing area is filled with a smooth interpolation (Laplace fill) and softened, giving the background's gradient.
   3. A grid the size of the box is built: inside the photo it uses that gradient, outside it extends the nearest
      edge tone. It is painted as the box background (smoothly upscaled), so the box follows the photo's tones.
   4. The feather mask (assets/tle-tint.css) is sized to the visible photo, not to the padded <img> box.
   Photos whose border is the watch itself (macro / close-ups) get a plain white box. Transparent PNGs are left alone. */
(function () {
  var PAIRS = [
    ['.tle-product__media', 'img.tle-product__img:not(.tle-product__img--alt)'],
    ['.tlr__product-media', 'img'],
    ['.tlp-main-image', 'img'],
    ['.tlp-thumb', 'img'],
    ['.tlp-related-card', 'img']
  ];
  var cache = {};
  function lum(c) { return .299 * c[0] + .587 * c[1] + .114 * c[2]; }
  function dist(a, b) { return Math.abs(a[0] - b[0]) + Math.abs(a[1] - b[1]) + Math.abs(a[2] - b[2]); }
  function med(arr, k) { var v = arr.map(function (c) { return c[k]; }).sort(function (a, b) { return a - b; }); return v[v.length >> 1]; }
  function avg4(f, W, H, k, X, Y) {
    var s = [0, 0, 0], n = 0;
    if (X > 0) { s[0] += f[k - 1][0]; s[1] += f[k - 1][1]; s[2] += f[k - 1][2]; n++; }
    if (X < W - 1) { s[0] += f[k + 1][0]; s[1] += f[k + 1][1]; s[2] += f[k + 1][2]; n++; }
    if (Y > 0) { s[0] += f[k - W][0]; s[1] += f[k - W][1]; s[2] += f[k - W][2]; n++; }
    if (Y < H - 1) { s[0] += f[k + W][0]; s[1] += f[k + W][1]; s[2] += f[k + W][2]; n++; }
    return [s[0] / n, s[1] / n, s[2] / n];
  }

  function analyse(probe) {
    var W = 28, H = Math.max(4, Math.round(28 * probe.height / probe.width));
    var c = document.createElement('canvas'); c.width = W; c.height = H;
    var x = c.getContext('2d', { willReadFrequently: true }); x.drawImage(probe, 0, 0, W, H);
    var d = x.getImageData(0, 0, W, H).data, grid = [], ring = [], clear = 0;
    for (var i = 0; i < W * H; i++) { grid.push([d[i * 4], d[i * 4 + 1], d[i * 4 + 2]]); if (d[i * 4 + 3] < 200) clear++; }
    if (clear / (W * H) > .15) return null;
    var idx = [];
    for (var X = 0; X < W; X++) idx.push(X);
    for (var Y = 1; Y < H; Y++) idx.push(Y * W + W - 1);
    for (X = W - 2; X >= 0; X--) idx.push((H - 1) * W + X);
    for (Y = H - 2; Y > 0; Y--) idx.push(Y * W);
    idx.forEach(function (k) { ring.push(grid[k]); });
    var m = [med(ring, 0), med(ring, 1), med(ring, 2)];
    var smooth = 0, near = 0;
    for (i = 0; i < ring.length; i++) {
      if (dist(ring[i], ring[(i + 1) % ring.length]) < 24) smooth++;
      if (dist(ring[i], m) < 60) near++;
    }
    if (!(smooth / ring.length > .7 && near / ring.length > .6 && lum(m) > 110)) return { white: true };
    var fixed = new Uint8Array(W * H), f = grid.map(function () { return m.slice(); });
    idx.forEach(function (k) {
      var p = grid[k], prev = grid[idx[(idx.indexOf(k) + idx.length - 1) % idx.length]], next = grid[idx[(idx.indexOf(k) + 1) % idx.length]];
      if (dist(p, m) < 36 && dist(p, prev) < 20 && dist(p, next) < 20) { fixed[k] = 1; f[k] = p.slice(); }
    });
    for (var it = 0; it < 260; it++) for (Y = 0; Y < H; Y++) for (X = 0; X < W; X++) { var k = Y * W + X; if (!fixed[k]) f[k] = avg4(f, W, H, k, X, Y); }
    for (it = 0; it < 6; it++) { var g = f.map(function (v) { return v.slice(); }); for (Y = 0; Y < H; Y++) for (X = 0; X < W; X++) { k = Y * W + X; var a4 = avg4(g, W, H, k, X, Y); f[k] = [(g[k][0] + a4[0]) / 2, (g[k][1] + a4[1]) / 2, (g[k][2] + a4[2]) / 2]; } }
    return { W: W, H: H, f: f, base: 'rgb(' + m.join(',') + ')' };
  }

  function contentRect(img) {
    var r = img.getBoundingClientRect(), cs = getComputedStyle(img);
    var pl = parseFloat(cs.paddingLeft) || 0, pr = parseFloat(cs.paddingRight) || 0, pt = parseFloat(cs.paddingTop) || 0, pb = parseFloat(cs.paddingBottom) || 0;
    var bw = r.width - pl - pr, bh = r.height - pt - pb, nw = img.naturalWidth || bw, nh = img.naturalHeight || bh;
    var sc = cs.objectFit === 'cover' ? Math.max(bw / nw, bh / nh) : Math.min(bw / nw, bh / nh);
    var w = Math.min(bw, nw * sc), h = Math.min(bh, nh * sc);
    return { left: r.left + pl + (bw - w) / 2, top: r.top + pt + (bh - h) / 2, width: w, height: h, el: r };
  }

  function paint(box, img, a) {
    if (!a) { clear(box, img); return; }
    var pr = contentRect(img);
    if (pr.width) {
      img.style.setProperty('--tle-mask-pos', (pr.left - pr.el.left) + 'px ' + (pr.top - pr.el.top) + 'px');
      img.style.setProperty('--tle-mask-size', pr.width + 'px ' + pr.height + 'px');
    }
    img.setAttribute('data-photo-bg', '');
    if (a.white) { box.style.setProperty('--tle-photo-bg', '#fff'); box.style.removeProperty('--tle-photo-grad'); box.setAttribute('data-photo-bg', 'white'); return; }
    box.style.setProperty('--tle-photo-bg', a.base);
    var br = (box.classList.contains('tlp-related-card') ? img : box).getBoundingClientRect();
    if (!br.width || !pr.width) { box.setAttribute('data-photo-bg', 'flat'); return; }
    var GW = 36, GH = Math.max(4, Math.round(36 * br.height / br.width));
    var c = document.createElement('canvas'); c.width = GW; c.height = GH;
    var x = c.getContext('2d'), out = x.createImageData(GW, GH);
    for (var Y = 0; Y < GH; Y++) for (var X = 0; X < GW; X++) {
      var px = br.left + (X + .5) / GW * br.width, py = br.top + (Y + .5) / GH * br.height;
      var u = Math.min(1, Math.max(0, (px - pr.left) / pr.width)), v = Math.min(1, Math.max(0, (py - pr.top) / pr.height));
      var col = a.f[Math.round(v * (a.H - 1)) * a.W + Math.round(u * (a.W - 1))], k = (Y * GW + X) * 4;
      out.data[k] = col[0]; out.data[k + 1] = col[1]; out.data[k + 2] = col[2]; out.data[k + 3] = 255;
    }
    x.putImageData(out, 0, 0);
    box.style.setProperty('--tle-photo-grad', 'url(' + c.toDataURL() + ')');
    box.setAttribute('data-photo-bg', 'grad');
  }
  function clear(box, img) {
    box.removeAttribute('data-photo-bg'); img.removeAttribute('data-photo-bg');
    box.style.removeProperty('--tle-photo-bg'); box.style.removeProperty('--tle-photo-grad');
  }
  function apply(box, img) {
    var src = img.currentSrc || img.src; if (!src || src.indexOf('data:') === 0) return;
    var key = src.split('?')[0];
    if (cache[key] !== undefined) { paint(box, img, cache[key]); return; }
    var probe = new Image(); probe.crossOrigin = 'anonymous';
    probe.onload = function () { try { cache[key] = analyse(probe); } catch (e) { cache[key] = null; } paint(box, img, cache[key]); };
    probe.onerror = function () { cache[key] = null; clear(box, img); };
    probe.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'bg=2';
  }
  var bound = [];
  function bind(box, sel) {
    if (box.dataset.photoBound) return;
    box.dataset.photoBound = '1';
    var img = box.querySelector(sel); if (!img) return;
    bound.push([box, img]);
    img.addEventListener('load', function () { apply(box, img); });
    if (img.currentSrc || img.src) apply(box, img);
  }
  function scan(root) {
    root = root || document;
    PAIRS.forEach(function (p) { root.querySelectorAll(p[0]).forEach(function (box) { bind(box, p[1]); }); });
  }
  function refresh() { bound.forEach(function (b) { apply(b[0], b[1]); }); }
  var t;
  window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(refresh, 250); });
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { scan(); }); } else { scan(); }
  window.addEventListener('load', function () { scan(); refresh(); });
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();